import NextImage from 'next/image';
import type { JSX } from 'react';

import imgixLoader from './imgixLoader';
import type { ImageProps } from './types';
import getSrcUrl from './utils/getSrcUrl';

const Image = ({
  alt,
  format = 'jpg',
  src,
  ...props
}: ImageProps): JSX.Element => {
  if (!src) {
    throw new Error('No src provided for Image component.');
  }

  const srcUrl = getSrcUrl(src, format);

  return <NextImage alt={alt} loader={imgixLoader} src={srcUrl} {...props} />;
};

export default Image;
